import { forwardRef } from 'react';

function createPolymorphicComponent(component) {
  return component;
}
function polymorphicFactory(ui) {
  const Component = forwardRef(ui);
  return Component;
}
function factory(ui) {
  const Component = forwardRef(ui);
  return Component;
}

export { createPolymorphicComponent, factory, polymorphicFactory };
